var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelListSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 11,
  viewBox: "0 0 12 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M1.5 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m10.5.75v1.5H4v-1.5zM1.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m10.5.75v1.5H4v-1.5zM1.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M12 .75v1.5H4V.75z"
})));
export default SvgChannelListSm;